<div class="w-full max-w-[380px] px-4 py-5 bg-white rounded-xl shadow text-center space-y-6">
  <div class="grid grid-cols-3 gap-3">
    @for (img of animalImages; track img) {
      <img
        [src]="img"
        class="w-[70px] h-[70px] sm:w-[80px] sm:h-[80px] rounded-full cursor-pointer hover:scale-110 transition-transform object-cover mx-auto border-2"
      [ngClass]="{
        'border-[#3f3d7a] scale-110 ring-2 ring-offset-2 ring-[#3f3d7a]': selectedImage === img,
        'border-transparent': selectedImage !== img
      }"
        (click)="selectImage(img)"
        alt="Avatar"
        i18n-alt="@@ProfileImageDialog_AvatarImageAltText"
        />
    }
  </div>

  <div class="space-y-3">
    <div class="flex items-center gap-3">
      <mat-icon class="text-[#313756] text-[28px]">image</mat-icon>
      <button
        class="flex-1 border border-[#313756] text-[#313756] px-3 py-1.5 rounded-md text-sm font-medium text-left"
        (click)="triggerFileInput()"
        i18n="@@ProfileImageDialog_SelectFromLibrary"
        >
        Select from library
      </button>
      <input
        type="file"
        accept="image/*"
        #fileInput
        style="display: none"
        (change)="onFileSelected($event)"
        />
    </div>

    <div class="flex items-center gap-3">
      <mat-icon class="text-[#313756] text-[28px]">delete</mat-icon>
      <button
        class="flex-1 border border-[#313756] text-[#313756] px-3 py-1.5 rounded-md text-sm font-medium text-left"
        (click)="removeImage()"
        i18n="@@ProfileImageDialog_RemoveCurrentImage"
        >
        Deleted current
      </button>
    </div>
  </div>

  <div class="flex justify-between items-center pt-4">
    <button mat-button (click)="dialogRef.close(null)" class="text-black" i18n="@@ProfileImageDialog_Cancel">
      Cancel
    </button>
    <button
      mat-flat-button
      class="!bg-[#3f3d7a] !hover:bg-[#7c3aed] text-white px-5 py-2 rounded-md font-semibold shadow-md"
      (click)="confirmSelection()"
      i18n="@@ProfileImageDialog_Confirm"
      >
      Confirm
    </button>
  </div>
</div>
